

/**
 * @name AppointmentsListController
 * @description Controller for the appointments list component
 * @param {constant} STATUS The STATUS constant
 * @param {constant} SORTOPTIONS The SORTOPTIONS constant
 * @param {object} Appointments The appointments service
 * @param {object} MergeProjects The merge projects service
 * @param {unknown} $document unknown
 * @param {unknown} $state unknown
 * @param {object} Session The user session service
 * @param {unknown} _ The lodash service
 */
function AppointmentsListController(
  STATUS,
  SORTOPTIONS,
  Appointments,
  MergeProjects,
  $document,
  $state,
  Session,
  _
) {
  let vm = this;

  // Public functions
  vm.resetSearch = resetSearch;
  vm.searchTermsUpdated = searchTermsUpdated;
  vm.uiOnParamsChanged = uiOnParamsChanged;
  vm.loadPage = loadPage;
  vm.session = Session;

  // Public variabls
  vm.statusOptions = STATUS;
  vm.sortOptions = SORTOPTIONS;
  vm.loading = false;

  // Appointments are loaded in the state resolve.

  // Load search parameters from the params in the state defintion.
  vm.search = {
    page: vm.$transition$.params().page,
    status: vm.$transition$.params().status,
    sort: vm.$transition$.params().sort,
    search: vm.$transition$.params().search
  };

/**
 * @name searchTermsUpdated
 * @description Function to update the URL parameters by calling $state.go.
 * '.' calls the current state and loads new params based on changes in the
 * view form.
 */
  function searchTermsUpdated() {
    vm.search.page = '1';
    $state.go('.', vm.search, {reload: true});
  }

/**
 * @name uiOnParamsChanged
 * @description A ui-router function callback when param values change.
 * @param {object} newParams The name of the param that changed and its new value
 */
  function uiOnParamsChanged(newParams) {
    _.assign(vm.search, newParams);
    if (!_.isUndefined(newParams.status) ||
    !_.isUndefined(newParams.sort) ||
    !_.isUndefined(newParams.search)) {
      vm.search.page = '1';
    }
    $state.go('.', vm.search, {reload: true});
  }

/**
 * @name loadPage
 * @description Updates the page number in vm.search and calls $state.go to
 * update the URL with the new page number.
 * @param {number} page The new page number.
 */
  function loadPage(page) {
    vm.search.page = page.toString();
    $state.go('.', vm.search, {reload: true});
  }

/**
  * @name resetSearch
  * @description Remove the text input field value to trigger the watcher on
  * local variable
  */
  function resetSearch() {
    vm.search.search = '';
    vm.search.page = '1';
    $state.go('.', vm.search, {reload: true});
  }
}

angular
  .module('inkfinder')
  .controller('AppointmentsListController', AppointmentsListController);



// WEBPACK FOOTER //
// ./components/appointments-list/appointments-list.controller.js